<!-- src/components/DownloadHint.vue -->
<template>
  <div>
    <div v-if="visible" class="download-hint">
      <span v-if="isWeixinBrowser">
        请下载我们的APP，点击
        <a :href="downloadLink" target="_blank">这里</a>
        获取下载链接
      </span>
      <span v-else>
        请下载我们的APP，点击
        <a :href="downloadLink" target="_blank">这里</a>
        获取下载链接 或
        <a href="javascript:void(0);" @click="openWeixin" class="weixin-link">打开微信</a>
      </span>
      <button @click="hideHint">今天不再提示</button>
    </div>
  </div>
</template>

<script>
import api from '../utils/api';

export default {
  computed: {
    visible() {
      return this.$store.state.hintVisible;
    },
  },
  data() {
    return {
      downloadLink: 'https://eforall.cn/app/index', // 替换为实际的APP下载链接
      weixinLink: 'weixin://dl/business/?t=BOYltbvsLEm', // 微信唤醒链接
      isWeixinBrowser: false, // 是否在微信浏览器中
    };
  },
  mounted() {
    // 检测是否在微信浏览器中
    this.checkWeixinBrowser();
  },
  methods: {
    hideHint() {
      // 设置过期时间为当天的凌晨12点
      const now = new Date();
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const expirationTime = tomorrow.getTime(); // 明天的0点的时间戳

      // 将过期时间保存到 localStorage
      localStorage.setItem('downloadHintExpiration', expirationTime);

      // 更新 Vuex 状态
      this.$store.commit('setHintVisible', false);
    },

    // 检测是否在微信浏览器中
    checkWeixinBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWeixinBrowser = /micromessenger/i.test(ua);
    },

    // 唤醒微信
    openWeixin() {
      try {
        window.location.href = this.weixinLink;

        // 设置一个定时器，如果一定时间后还在当前页面，说明唤醒失败
        setTimeout(() => {
          if (document.hidden || document.visibilityState === 'hidden') {
            // 页面已被隐藏，说明可能已经切换到微信了
            return;
          }
          // 如果没有唤醒成功，可以提示用户
          alert('请确保您已安装微信客户端');
        }, 2000);
      } catch (err) {
        console.error('打开微信失败', err);
        alert('无法打开微信，请手动打开微信扫描二维码');
      }
    },
  },
  created() {
    // 初始化提示状态
    this.$store.dispatch('initializeHint');
  },
};
</script>

<style scoped>
.download-hint {
  background-color: #ffefc4;
  color: #000;
  padding: 10px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.weixin-link {
  color: #07c160;
  font-weight: bold;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadHint.vue